"use client";

import { useUser } from "@/hooks/useUser";
import { PageLoader } from "./PageLoader";

export const CoopPage = ({ children }: { children: React.ReactNode }) => {
  const { ready, holder } = useUser();
  const isReady = ready && holder.ready;

  return (
    <main className="min-h-screen">{isReady ? children : <PageLoader />}</main>
  );
};
